const fileData = {
    acceptedExtensions: {
        application: "application",
        audio: "audio/*",
        csv: "text/csv",
        document:
            "application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint, application/vnd.ms-word, application/pdf, application/ttml+xml, application/xml, text/plain, text/xml, .xlsx, .csv, .ttml",
        image: "image/*",
        lyrics: ".txt, .ttml",
        motionArtwork: "video/mp4, video/webm, video/quicktime",
        sshKey: ".ppk, .pem",
        text: "text",
        video: "video/*, .mxf",
        videoThumbnail: "image/jpeg, image/png, .jpg, .jpeg, .png",
        xml: "text/xml",
        zip: ".zip, application/zip, application/x-zip, application/x-zip-compressed",
    },
    extensions: {
        audio: ["mp3", "wav", "flac", "aac", "midi", "mpeg", "webm"],
        csv: ["csv"],
        document: [
            "pdf",
            "docx",
            "doc",
            "csv",
            "txt",
            "application",
            "xls",
            "ttml",
            "application/ttml+xml",
            "application/xml",
            "text/xml",
        ],
        image: ["png", "jpg", "jpeg", "webp"],
        lyrics: ["txt", "ttml", "text/plain"],
        motionArtwork: ["mp4", "mov", "quicktime"],
        sshKey: ["ppk", "pem"],
        video: ["mp4", "webm", "flv", "mov", "avi", "mkv", "wmv", "mxf", "mpeg", "mpg", "ogg"],
        videoThumbnail: ["png", "jpg", "jpeg"],
        xml: ["xml"],
        zip: ["zip"],
    },
    names: {
        assetsXml: "assetsXmlFile",
        bulkUpdateRelease: "bulkUpdateRelease",
        bulkUpdateTrack: "bulkUpdateTrack",
        document: "documentFile",
        image: "imageFile",
        lyrics: "lyricsFile",
        metadataXml: "metadataXmlFile",
        motionArtwork: "motionArtworkFile",
        releaseClientLinks: "releaseClientLinksFile",
        revenueReport: "revenueReportFile",
        revenueReportTemplate: "revenueReportTemplateFile",
        sshKey: "sshKeyFile",
        takedown: "takedownFile",
        track: "trackFile",
        video: "videoFile",
        videoThumbnail: "videoThumbnailFile",
        videoXml: "videoXmlFile",
        xml: "xmlFile",
        xmlType: "xmlType",
    },
    types: {
        artwork: "ArtWork",
        track: "Track",
        xml: "XML",
        zip: "ZIP",
    },
    uploadedTypes: {
        bulkUpdateRelease: "BULK_RELEASE_DOCUMENT",
        bulkUpdateTrack: "BULK_TRACK_DOCUMENT",
        documentFile: "DOCUMENT",
        imageFile: "IMAGE",
        lyricsFile: "LYRIC_FILE",
        motionArtworkFile: "MOTION_ART",
        releaseClientLinksFile: "DOCUMENT",
        revenueReportFile: "DOCUMENT",
        revenueReportTemplateFile: "DOCUMENT",
        sshKeyFile: "KEYFILE",
        takedownFile: "XML",
        trackFile: "TRACK",
        videoFile: "VIDEO",
        videoThumbnailFile: "IMAGE",
        xmlFile: "DOCUMENT",
        xmlType: "XML",
        zipFile: "ZIP",
    },
};

export default fileData;
